export const getCookie = () => {
  if (typeof document === 'undefined') {
    return null;
  }
  const cookies = document.cookie.split('; ');
  const readableCookies = {};

  cookies.forEach(cookie => {
    const [name, ...rest] = cookie.split('=');
    const value = decodeURIComponent(rest.join('='));

    try {
      // Try to parse if it's JSON
      readableCookies[name] = JSON.parse(value);
    } catch {
      readableCookies[name] = value;
    }
  });
  const { cc_cookie } = readableCookies || {};
  
  // Simple category-based consent (much cleaner!)
  let isAddsEnabled = false;
  let isGoogleAnalyticsEnabled = false;
  
  if (cc_cookie?.categories) {
    isAddsEnabled = cc_cookie.categories.includes('advertising');
    isGoogleAnalyticsEnabled = cc_cookie.categories.includes('analytics');
  }

  return {
    isAddsEnabled,
    isGoogleAnalyticsEnabled,
    isAllowedAll: isAddsEnabled && isGoogleAnalyticsEnabled,
  };
};
